module.exports = __webpack_public_path__ + "img/err.2ef6693b.svg";